import React from "react";
import { Route } from "react-router-dom";
import OnboardingWizard from "../components/onboarding/onboardingWizard";

const Onboarding = () => {
	return (
		<div className="boxWrap">
			<Route exact path="/onboarding" render={props => <OnboardingWizard {...props} step={1} />} />
			<Route exact path="/onboarding/step2" render={props => <OnboardingWizard {...props} step={2} />} />
			<Route exact path="/onboarding/step3" render={props => <OnboardingWizard {...props} step={3} />} />
			<Route exact path="/onboarding/step4" render={props => <OnboardingWizard {...props} step={4} />} />
			<Route exact path="/onboarding/step5" render={props => <OnboardingWizard {...props} step={5} />} />
		</div>
	);
};

export default Onboarding;
